import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';
import { f as fetchHTML } from './fetchHTML-CGNR3V1z.js';
import './parseHTML-Om2c1Ayj.js';

class PredictiveSearchResults extends HTMLElement {
  #unsubscriber;
  #abortController;

  connectedCallback() {
    this.#unsubscriber = PubSub.subscribe('search:input', (options) => this.#fetchResults(options));
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#unsubscriber();
  }

  async #fetchResults(options) {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    const url = new URL(location.href);
    url.searchParams.set('section_id', 'predictive-search-drawer');

    if (options.data.value) {
      url.pathname = routes.predictive_search_url;
      url.searchParams.set('q', options.data.value);
      url.searchParams.set('resources[limit]', 4);
      url.searchParams.set('resources[limit_scope]', 'each');
    }

    try {
      const html = await fetchHTML(url.toString(), { signal });
      const results = html.querySelector('predictive-search-results');
      this.innerHTML = results.innerHTML;
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('PredictiveSearchResults fetchResults error', error);
    }
  }
}

customElements.define('predictive-search-results', PredictiveSearchResults);
